import React from "react";
import PageTitle from "../../Shared/PageTitle/PageTitle";
import abimg from "../../../assets/images/about-gehl.webp";
import Discuss from "./components/Discuss";
import PartnersSection from "./components/partnersSection";
import AboutPresentation from "./components/AboutPresentation";
const About = () => {
  return (
    <>
      <PageTitle title={"A propos de nous"} currentPage={"A propos de nous"} />

      <div className="wpo-project-single-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="wpo-project-single-wrap">
                <div className="wpo-project-single-item">
                  <AboutPresentation abimg={abimg} />
                  <div className="wpo-project-single-item list-widget">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="wpo-project-single-title">
                          <h3>Notre Stratégie</h3>
                        </div>
                        <p>
                          Notre engagement est de vous fournir la meilleure
                          qualité de service et d’expertise dans le domaine du
                          matériel BTP et d’équipements industriels. En
                          partenariat avec des constructeurs de renommée
                          mondiale et en vous offrant des équipements de
                          qualité, nous nous engageons à vous accompagner et
                          vous conseiller pour un meilleur rendement et une
                          exploitation optimale de vos machines.
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <div className="wpo-project-single-item-quote">
                          <p>
                            "SEMAT est une nouvelle vision du métier de
                            concessionnaire de matériel BTP."
                          </p>
                          <span>
                            SEMAT - <span>Pour Vos Machines</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpo-project-single-item">
                    <div className="wpo-project-single-title">
                      <h3
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        Nos Partenaires
                      </h3>
                    </div>
                    <PartnersSection />
                  </div>

                  <Discuss />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
